export const PWNED_PASSWORD_HASH_PREFIX_LENGTH = 5;

export type PwnedPasswordHashResponse = {
  hashes: string[];
};

export async function generateSHA1Hash(password: string): Promise<string> {
  const digest = await window.crypto.subtle.digest(
    "SHA-1",
    new TextEncoder().encode(password),
  );
  const sha1Hash = Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

  return sha1Hash;
}

/**
 * 与えられた sha1Hash と tenant-management (実際は pwned-checker) から取得したハッシュリストを比較し、漏洩済みのパスワードかどうかを判定する
 * @param sha1Hash SHA-1 hash of the password.
 * @param hases List of hashes from pwned-checker.
 * @returns True if the password is pwned, false otherwise.
 * @see https://github.com/graffer-inc/pwned-checker
 **/
export function isPwnedPasswordHash(
  sha1Hash: string,
  hases: string[],
): boolean {
  return hases.some((hash) => {
    const hashPrefix = sha1Hash.slice(0, PWNED_PASSWORD_HASH_PREFIX_LENGTH);
    return sha1Hash.toUpperCase() === hashPrefix.concat(hash).toUpperCase();
  });
}
